import { render, staticRenderFns } from "./IconsDropdown.vue?vue&type=template&id=79adc4aa&scoped=true"
import script from "./IconsDropdown.vue?vue&type=script&lang=js"
export * from "./IconsDropdown.vue?vue&type=script&lang=js"
import style0 from "./IconsDropdown.vue?vue&type=style&index=0&id=79adc4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79adc4aa",
  null
  
)

export default component.exports